module.exports = __webpack_public_path__ + "static/img/20240927_2.019a7fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240927_2.png
// module id = N5HC
// module chunks = 0